import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { FormSpecimen } from './FormSpecimen';
import { ModalButtonSave, ModalButtonUpdate,  } from '../../constant';
import { DeleteSpecimen } from './DeleteSpecimen';

export const ModalSpecimens = (props) => {

    const{
        modal, modalTitle, toggle, method, loading,
        name, abbreviation, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete
    } = props;

    return (
        <Modal isOpen = {modal} toggle={toggle} backdrop='static' keyboard={false} centered={true}>
            <ModalHeader toggle={ toggle } className="bg-primary">
                {modalTitle}
            </ModalHeader>
            {
                method === "create"
                ? 
                    <FormSpecimen
                        button={ModalButtonSave}
                        {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                :
                    (method === "update")
                        ?
                            <FormSpecimen
                                button={ModalButtonUpdate}
                                {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }}
                            />
                        :
                            <DeleteSpecimen {...{ toggle, loading, name, abbreviation, saveDelete }} />
            }
        </Modal>
    )
}
